<template>
<div class="footer" :class="is_PC?'pc-footer':'m-footer'">
    <div class="footer-content">
        <div class="Collection-net">
            <p class="footer-title">公司介绍</p>
            <h1>{{schoolData.SchoolName}}</h1>
            <h5>地址：{{schoolData.SchoolAdd}}</h5>
            <el-button type="primary" icon="el-icon-position" size="mini" v-if="is_wechat" @click="openLocation()">点击导航</el-button>
            <h5>电话：{{schoolData.SchoolPhone}}</h5>
            <h5>邮箱：{{schoolData.SchoolEmail}}</h5>
            <h5>邮编：{{schoolData.SchoolZip}}</h5>
        </div>
        <!-- <div class="friends-net">
            <p class="footer-title">友情链接</p>
            <ul>
                <li>
                    <a href="#" title="" target="_blank">有爱设计</a>
                </li>
            </ul>
        </div> -->
        <div :class="is_PC?'pc-code':'m-code'" v-if="schoolData.ShowConnect==0">
            <div class="baidu-box " v-if="is_PC">
                <p class="footer-title">莫卡乐概念美术(服务号)</p>
                <div class="wechat-code">
                    <img style="width: 100%;" :src="schoolData.SchoolWeChatGroupCode" />

                </div>
            </div>
            <div class="baidu-box m-code-box">
                <p class="footer-title">莫卡乐概念美术馆(订阅号)</p>
                <div class="wechat-code">
                    <img v-show="!is_wechat" style="width: 100%;" :src="schoolData.SchoolWeChatPublicCode" />
                    <img v-show="is_wechat" style="width: 100%;" :src="schoolData.SchoolWeChatPublicCode" @click="previewImage(schoolData.SchoolWeChatPublicCode)" />
                </div>
            </div>
            <div class="wechat-box m-code-box">
                <p class="footer-title">莫卡乐概念美术馆(抖音号)</p>
                <div class="douyin">
                    <el-image v-show="!is_wechat" style="width: 100%;" :src="schoolData.SchoolDouYinCode" :preview-src-list="[schoolData.SchoolDouYinCode]" fit="cover"></el-image>
                    <el-image v-show="is_wechat" style="width: 100%;" :src="schoolData.SchoolDouYinCode" fit="cover" @click="previewImage(schoolData.SchoolDouYinCode)"></el-image>
                </div>

                <p class="footer-title" style="margin-top:20px;">联系我们:</p>
                <div class="nav-right-box">
                    <a href="javascript:;" @click="postWeChatCenterDialogVisibleTrue">
                        <div class="wechat chat"></div>
                    </a>
                    <a href="javascript:;" @click="qqIM">
                        <div class="qq chat"></div>
                    </a>
                    <a href="javascript:;" @click="sendEmail">
                        <div class="email chat"></div>
                    </a>
                </div>

            </div>
        </div>
    </div>
    <div class="footer-copyright">
        <p>Copyright © 2018 ~ 2025 版权所有 <a style="color:#57BC4C;" href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备19026686号-1</a> 技术支持 By <a style="color:#20A0FF!important;" target="_blank" href="http://nas.5windy.com:3000/#/about">Windy</a>.</p>
    </div>
</div>
</template>

<script>
import wxApi from '@/assets/publicJS/WechatShare.js';
export default {
    data() {
        return {
            //获取当前登录设备
            is_PC: this.$store.state.is_PC,
            is_wechat: this.$store.state.is_wechat,
            // 学校信息
            schoolData: {
                SchoolName: '莫卡乐教育发展研究机构有限公司',
                SchoolEnglishName: 'more-color td.',
                SchoolLogo: '',
                SchoolType: '美术',
                SchoolPhone: '150-7105-5503',
                SchoolAdd: '湖北省武汉市蔡甸区蔡甸大街齐联里88号',
                SchoolZip: '430100',
                SchoolEmail: 'bob23456@163.com',
                SchoolNet: 'http://home.5windy.com:8000/',
                SchoolQQ: '361203947',
                SchoolWeChatGroupCode: 'static/img/wechat_code.png',
                SchoolWeChatPublicCode: 'static/img/wechat_code.png',
                SchoolDouYinCode: 'static/img/douyinCode.png',
            },
        }
    },
    components: {

    },

    computed: {

    },
    created() {
        this.getSchoolInfotmation()
    },

    methods: {
        //微信图片查看
        previewImage(img) {
            let list = ['http://moocono.com/' + img, ]
            let imgList = {
                img: 'http://moocono.com/' + img,
                imgs: list
            }
            // console.log(imgList)
            // 将配置注入通用方法
            wxApi.previewImage(imgList);
        },
        //微信内部地图导航
        openLocation() {
            let opstion = {
                name: this.schoolData.SchoolName, // 分享标题
                address: this.schoolData.SchoolAdd,
                success: function () {},
                error: function () {}
            }
            // 将配置注入通用方法
            wxApi.wxRegister(wxApi.openLocation(opstion));
        },
        //打开微信二维码
        postWeChatCenterDialogVisibleTrue() {
            this.$store.commit('updateCenterDialogVisible', true)
            this.$store.commit('updatemodalStatus', "wechat")
        },
        //QQ聊天
        qqIM() {
            window.open('http://wpa.qq.com/msgrd?v=3&uin=' + this.schoolData.SchoolQQ + '&site=qq&menu=yes', '_blank', 'height=502, width=644,toolbar=no,scrollbars=no,menubar=no,status=no');
        },
        //发送邮件
        sendEmail() {
            window.open('mailto:' + this.schoolData.SchoolEmail, '_blank', 'height=502, width=644,toolbar=no,scrollbars=no,menubar=no,status=no');
        },
        //获取学校联系方式资料
        getSchoolInfotmation() {
            let params = '';
            this.$store.dispatch('get_school_information', params).then((response) => {
                let res = response;
                // console.log(response)
                if (res.statusText === 'OK' || res.status === 200) {
                    // console.log(res.data)
                    this.schoolData = res.data[0];
                    this.schoolData.SchoolWeChatGroupCode = 'media/' + res.data[0].SchoolWeChatGroupCode
                    this.schoolData.SchoolWeChatPublicCode = 'media/' + res.data[0].SchoolWeChatPublicCode
                    this.schoolData.SchoolDouYinCode = 'media/' + res.data[0].SchoolDouYinCode
                    //更新后的资料存到localStorage缓存区
                    localStorage.setItem("school", JSON.stringify(res.data[0]));
                    //同时更新后的资料存到Vuex
                    this.$store.commit('update_schoolInformation', res.data[0]);
                } else {
                    this.$message.error(res.detail);
                }
            }).catch(err => {
                console.error(err);
                // this.$message.error("您当前网络有问题，请稍后再试。");
            });
        },
    },
}
</script>

<style scoped>
@import './footer.css';

.footer>>>.el-image-viewer__canvas img {
    width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue